/*!
 * (C) Larva.io http://larva.io - Seee LICENSE.md
 */
import { r as registerInstance, c as createEvent, h, g as getElement } from './index-ef0fa435.js';
import { h as hooks } from './moment-b1f57f1a.js';
import { i as isObject } from './isObject-036bb226.js';

const utilityMeterCss = "slot-fb[hidden],slot[hidden]{display:initial !important}";

const UtilityMeter = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.output = createEvent(this, "output", 7);
    this.request = createEvent(this, "request", 7);
    this.measuringUnit = '';
    this.webComponentValueType = 'abs';
    this.icon = 'chart-bar';
    this.color = 'primary';
    this.colorModal = undefined;
    this.colorInputs = undefined;
    this.colorIconSmall = undefined;
    this.hideTitles = undefined;
    this.supTitle = undefined;
    this.subTitle = undefined;
    this.log = false;
    this.mainTitle = undefined;
    this.nodeSize = 'default';
    this.loading = true;
    this.values = [];
  }
  /**
   * Larva error input
   */
  async error(data) {
    if (this.node) {
      this.node.error(data);
    }
    this.loading = false;
  }
  /**
   * Larva input message
   */
  async input(state) {
    this.loading = false;
    if (isObject(state) && state.months) {
      this.values = state.months;
      // tslint:disable-next-line: strict-boolean-conditions
      if (state.webComponentValueType) {
        this.webComponentValueType = state.webComponentValueType;
      }
      // tslint:disable-next-line: strict-boolean-conditions
      if (state.measuringUnit) {
        this.measuringUnit = state.measuringUnit;
      }
    }
  }
  componentDidLoad() {
    const el = this.el.shadowRoot || this.el;
    this.node = el.querySelector('lar-node');
    this.loading = true;
    this.output.emit();
  }
  render() {
    const months = this.values && Array.isArray(this.values) ? this.values : [];
    let latestMonth = months.length > 0 ? months[0] : null;
    if (latestMonth && latestMonth.date !== hooks().format('MM-YYYY')) {
      latestMonth = null;
    }
    let value;
    switch (this.webComponentValueType) {
      case 'abs': {
        if (latestMonth) {
          value = `${latestMonth.abs}${this.measuringUnit}`;
        }
        break;
      }
      case 'rel': {
        if (latestMonth) {
          value = `${latestMonth.rel}${this.measuringUnit}`;
        }
        break;
      }
      // none
    }
    const componentProps = {
      measuringUnit: this.measuringUnit,
      webComponentValueType: this.webComponentValueType,
      values: JSON.stringify(this.values)
    };
    return [
      h("lar-node", { value: value, hideTitles: this.hideTitles, icon: this.icon, color: this.color, supTitle: this.supTitle, mainTitle: this.mainTitle, subTitle: this.subTitle, colorModal: this.colorModal, colorInputs: this.colorInputs, colorIconSmall: this.colorIconSmall, log: this.log, loading: this.loading, nodeSize: this.nodeSize, component: "lar-utility-log", componentProps: componentProps }, h("slot", null))
    ];
  }
  get el() { return getElement(this); }
};
UtilityMeter.style = utilityMeterCss;

export { UtilityMeter as lar_utility_meter };

//# sourceMappingURL=lar-utility-meter.entry.js.map